// extracted by mini-css-extract-plugin
module.exports = {"googleMap":"googleMap-module--googleMap--6943z","marker":"googleMap-module--marker--3Itkd","text":"googleMap-module--text--2ivTQ"};